import { render, staticRenderFns } from "./InsureNotices.vue?vue&type=template&id=f77811f0&scoped=true&"
import script from "./InsureNotices.vue?vue&type=script&lang=js&"
export * from "./InsureNotices.vue?vue&type=script&lang=js&"
import style0 from "./InsureNotices.vue?vue&type=style&index=0&id=f77811f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77811f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f77811f0')) {
      api.createRecord('f77811f0', component.options)
    } else {
      api.reload('f77811f0', component.options)
    }
    module.hot.accept("./InsureNotices.vue?vue&type=template&id=f77811f0&scoped=true&", function () {
      api.rerender('f77811f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/InsureNotices.vue"
export default component.exports